/* global Blockly */
import React from 'react';

export const BLOCK_NAME = 'snap_action_log_out';

function defineBlock() {
    return {
        init: function () {
            this.appendValueInput('MESSAGE')
                .appendField('log out from Snap')
                .appendField(new Blockly.FieldDropdown([['with prompt', 'false'], ['without prompt', 'true']], undefined, undefined), 'FORCE')
                .appendField(' and success message ');
            this.setPreviousStatement(true);
            this.setNextStatement(true);
            this.setColour(Blockly.Msg.APP_ACTIONS_HUE);
            this.setTooltip('Log out the currently logged in Snap user.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + '#app-actions');
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let message = Blockly.JavaScript.valueToCode(block, 'MESSAGE', Blockly.JavaScript.ORDER_NONE);
            let force = block.getFieldValue('FORCE');
            return `Snap.user.logout(${force}, ${message}); \n`;
        }
    }
}

const SnapActionLogOut = function (options) {
    SnapActionLogOut.blockName = BLOCK_NAME;

    Blockly.Blocks[BLOCK_NAME] = defineBlock();
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][BLOCK_NAME] = generators[i];
    } 

    if (options.context.appTypeId !== 2 && options.context.appTypeId !== 3) {
        return null;
    }

    return (
        <block type={BLOCK_NAME}>
            <value name='MESSAGE'>
                <shadow type='text'/>
            </value>
        </block>
    );
};

export default SnapActionLogOut;
